
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacyrequest",
      function () {
        return require("private-next-pages/privacyrequest/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacyrequest"])
      });
    }
  